export default [
  {
    code: 'AF',
    name: 'Afghanistan',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'AX',
    name: 'Åland Islands',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'AL',
    name: 'Albania',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'DZ',
    name: 'Algeria',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'AS',
    name: 'American Samoa',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'AD',
    name: 'Andorra',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'AO',
    name: 'Angola',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'AI',
    name: 'Anguilla',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'AQ',
    name: 'Antarctica',
    continent_code: 'AN',
    continent_name: 'Antarctica'
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'AR',
    name: 'Argentina',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'AM',
    name: 'Armenia',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'AW',
    name: 'Aruba',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'AU',
    name: 'Australia',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'AT',
    name: 'Austria',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'BS',
    name: 'Bahamas',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'BH',
    name: 'Bahrain',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'BB',
    name: 'Barbados',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'BY',
    name: 'Belarus',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'BE',
    name: 'Belgium',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'BZ',
    name: 'Belize',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'BJ',
    name: 'Benin',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'BM',
    name: 'Bermuda',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'BT',
    name: 'Bhutan',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'BO',
    name: 'Bolivia',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'BW',
    name: 'Botswana',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
    continent_code: 'AN',
    continent_name: 'Antarctica'
  },
  {
    code: 'BR',
    name: 'Brazil',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'BI',
    name: 'Burundi',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'KH',
    name: 'Cambodia',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'CM',
    name: 'Cameroon',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'CA',
    name: 'Canada',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'CV',
    name: 'Cape Verde',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'CF',
    name: 'Central African Republic',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'TD',
    name: 'Chad',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'CL',
    name: 'Chile',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'CN',
    name: 'China',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'CX',
    name: 'Christmas Island',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'CO',
    name: 'Colombia',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'KM',
    name: 'Comoros',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'CG',
    name: 'Congo',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'CD',
    name: 'Congo, The Democratic Republic of the',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'CK',
    name: 'Cook Islands',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'CI',
    name: 'Cote D"Ivoire',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'HR',
    name: 'Croatia',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'CU',
    name: 'Cuba',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'CY',
    name: 'Cyprus',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'DK',
    name: 'Denmark',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'DJ',
    name: 'Djibouti',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'DM',
    name: 'Dominica',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'EC',
    name: 'Ecuador',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'EG',
    name: 'Egypt',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'SV',
    name: 'El Salvador',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'ER',
    name: 'Eritrea',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'EE',
    name: 'Estonia',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'FK',
    name: 'Falkland Islands (Malvinas)',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'FJ',
    name: 'Fiji',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'FI',
    name: 'Finland',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'FR',
    name: 'France',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'GF',
    name: 'French Guiana',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'PF',
    name: 'French Polynesia',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'TF',
    name: 'French Southern Territories',
    continent_code: 'AN',
    continent_name: 'Antarctica'
  },
  {
    code: 'GA',
    name: 'Gabon',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'GM',
    name: 'Gambia',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'GE',
    name: 'Georgia',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'DE',
    name: 'Germany',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'GH',
    name: 'Ghana',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'GR',
    name: 'Greece',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'GL',
    name: 'Greenland',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'GD',
    name: 'Grenada',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'GU',
    name: 'Guam',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'GT',
    name: 'Guatemala',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'GG',
    name: 'Guernsey',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'GN',
    name: 'Guinea',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'GY',
    name: 'Guyana',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'HT',
    name: 'Haiti',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'HM',
    name: 'Heard Island and Mcdonald Islands',
    continent_code: 'AN',
    continent_name: 'Antarctica'
  },
  {
    code: 'VA',
    name: 'Holy See (Vatican City State)',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'HN',
    name: 'Honduras',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'HU',
    name: 'Hungary',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'IS',
    name: 'Iceland',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'IN',
    name: 'India',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'ID',
    name: 'Indonesia',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'IR',
    name: 'Iran, Islamic Republic Of',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'IQ',
    name: 'Iraq',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'IE',
    name: 'Ireland',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'IM',
    name: 'Isle of Man',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'IL',
    name: 'Israel',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'IT',
    name: 'Italy',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'JM',
    name: 'Jamaica',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'JP',
    name: 'Japan',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'JE',
    name: 'Jersey',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'JO',
    name: 'Jordan',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'KE',
    name: 'Kenya',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'KI',
    name: 'Kiribati',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'KP',
    name: 'Korea, Democratic People"S Republic of',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'KR',
    name: 'Korea, Republic of',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'KW',
    name: 'Kuwait',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'LA',
    name: 'Lao People"S Democratic Republic',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'LV',
    name: 'Latvia',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'LB',
    name: 'Lebanon',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'LS',
    name: 'Lesotho',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'LR',
    name: 'Liberia',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'LY',
    name: 'Libyan Arab Jamahiriya',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'LT',
    name: 'Lithuania',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'MO',
    name: 'Macao',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'MK',
    name: 'Macedonia, The Former Yugoslav Republic of',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'MG',
    name: 'Madagascar',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'MW',
    name: 'Malawi',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'MY',
    name: 'Malaysia',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'MV',
    name: 'Maldives',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'ML',
    name: 'Mali',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'MT',
    name: 'Malta',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'MQ',
    name: 'Martinique',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'MR',
    name: 'Mauritania',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'MU',
    name: 'Mauritius',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'YT',
    name: 'Mayotte',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'MX',
    name: 'Mexico',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'FM',
    name: 'Micronesia, Federated States of',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'MD',
    name: 'Moldova, Republic of',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'ME',
    name: 'Montenegro',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'MC',
    name: 'Monaco',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'MN',
    name: 'Mongolia',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'MS',
    name: 'Montserrat',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'MA',
    name: 'Morocco',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'MM',
    name: 'Myanmar',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'NA',
    name: 'Namibia',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'NR',
    name: 'Nauru',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'NP',
    name: 'Nepal',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'NL',
    name: 'Netherlands',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'AN',
    name: 'Netherlands Antilles',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'NC',
    name: 'New Caledonia',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'NE',
    name: 'Niger',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'NG',
    name: 'Nigeria',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'NU',
    name: 'Niue',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'NO',
    name: 'Norway',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'OM',
    name: 'Oman',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'PK',
    name: 'Pakistan',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'PW',
    name: 'Palau',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'PS',
    name: 'Palestinian Territory, Occupied',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'PA',
    name: 'Panama',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'PY',
    name: 'Paraguay',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'PE',
    name: 'Peru',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'PH',
    name: 'Philippines',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'PN',
    name: 'Pitcairn',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'PL',
    name: 'Poland',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'PT',
    name: 'Portugal',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'QA',
    name: 'Qatar',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'RE',
    name: 'Reunion',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'RO',
    name: 'Romania',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'RU',
    name: 'Russian Federation',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'RW',
    name: 'RWANDA',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'SH',
    name: 'Saint Helena',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'WS',
    name: 'Samoa',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'SM',
    name: 'San Marino',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'SN',
    name: 'Senegal',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'RS',
    name: 'Serbia',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'SC',
    name: 'Seychelles',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'SG',
    name: 'Singapore',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'SK',
    name: 'Slovakia',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'SI',
    name: 'Slovenia',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'SO',
    name: 'Somalia',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'ZA',
    name: 'South Africa',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    continent_code: 'AN',
    continent_name: 'Antarctica'
  },
  {
    code: 'ES',
    name: 'Spain',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'SD',
    name: 'Sudan',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'SR',
    name: 'Suriname',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'SZ',
    name: 'Swaziland',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'SE',
    name: 'Sweden',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'CH',
    name: 'Switzerland',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'TW',
    name: 'Taiwan, Province of China',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'TZ',
    name: 'Tanzania, United Republic of',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'TH',
    name: 'Thailand',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'TG',
    name: 'Togo',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'TK',
    name: 'Tokelau',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'TO',
    name: 'Tonga',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'TN',
    name: 'Tunisia',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'TR',
    name: 'Turkey',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'TV',
    name: 'Tuvalu',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'UG',
    name: 'Uganda',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'UA',
    name: 'Ukraine',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'GB',
    alt_code: 'EN',
    name: 'United Kingdom',
    continent_code: 'EU',
    continent_name: 'Europe'
  },
  {
    code: 'US',
    name: 'United States',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'UY',
    name: 'Uruguay',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'VU',
    name: 'Vanuatu',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'VE',
    name: 'Venezuela',
    continent_code: 'SA',
    continent_name: 'South America'
  },
  {
    code: 'VN',
    name: 'Viet Nam',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'VG',
    name: 'Virgin Islands, British',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'VI',
    name: 'Virgin Islands, U.S.',
    continent_code: 'NA',
    continent_name: 'North America'
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
    continent_code: 'OC',
    continent_name: 'Oceania'
  },
  {
    code: 'EH',
    name: 'Western Sahara',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'YE',
    name: 'Yemen',
    continent_code: 'AS',
    continent_name: 'Asia'
  },
  {
    code: 'ZM',
    name: 'Zambia',
    continent_code: 'AF',
    continent_name: 'Africa'
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
    continent_code: 'AF',
    continent_name: 'Africa'
  }
]